var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TreeSelect',{directives:[{name:"width",rawName:"v-width",value:("100%"),expression:"\"100%\""}],attrs:{"data":_vm.shopList,"disabled":_vm.disabled,"placeholder":"请选择店铺分类"},model:{value:(_vm.currValue),callback:function ($$v) {_vm.currValue=$$v},expression:"currValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }